//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/*
 * The following is a simple, universal search directive. It can be used anywhere a
 * generic search box is required on the site.
 *
 * @param placeholderText  The text that is pre-populated in the input element
 * @param action           The function that is to be executed when a user searches. The action passed in must take
 *                             a string that represents the search term.
 * @param automatic        If true, searches will be run automatically after @delay milliseconds of unchanged input
 * @param delay            The number of milliseconds to wait between keystrokes before search is
 *                             executed automatically (this only has an effect if @automatic is true)
 */
(function() {
  const curalate = angular.module('curalate');

  curalate.directive('searchBar',
    () => ({
      restrict: 'E',
      scope: {
        placeholderText: '@',
        action: '&',
        delay: '=',
        automatic: '=',
        trackingCategory: '@',
      },
      template: require('@partials/search-bar.html'),
      controller: ['$scope', 'TrackingService', function($scope, TrackingService) {
        $scope.model = {
          focus: false,
        };

        // These change the value of focus to allow custom button styling
        $scope.model.setFocus = function() { $scope.model.focus = true; };
        $scope.model.setBlur = function() { $scope.model.focus = false; };

        // Ignore the initial call to triggerAction() from the $watch function.
        $scope.model.triggerAction = _.after($scope.automatic ? 2 : 1, () => {
          TrackingService.recordEvent($scope.trackingCategory, 'Search', $scope.model.query);
          $scope.action({ query: $scope.model.query });
        });

        $scope.model.searchButtonClicked = function() {
          $scope.model.triggerAction();
        };

        // If $scope.automatic is true, we'll automatically run the action function after $scope.delay ms (or 500)
        if ($scope.automatic) {
          $scope.$watch('model.query', _.throttle($scope.model.triggerAction, $scope.delay || 500, { leading: false }));
        }
      }],
    }),
  );
})();
